import React, { useState, useEffect, useRef } from 'react';
import { Card, Tabs, Space, Tag, Typography, Divider, Button, message } from 'antd';
import { ReloadOutlined, FullscreenOutlined } from '@ant-design/icons';
import { Sankey } from '@antv/g2plot';
import SimpleAlluvialDemo from '../components/SimpleAlluvialDemo';

const { Title, Text } = Typography;

const SankeyFlowDemo = () => {
    const [activeTab, setActiveTab] = useState('horizontal');
    const horizontalChartRef = useRef(null);
    const verticalChartRef = useRef(null);
    const horizontalContainerRef = useRef(null);
    const verticalContainerRef = useRef(null);

    // 横向时间轴 - 许可申请场景数据（按时间层次组织）
    const horizontalData = [
        // Layer 1: 航班源头
        { source: 'CT107 HGH→NQZ', target: 'Day1-许可需求', value: 1, stage: 'Day 1' },
        { source: 'CT108 HGH→LGG', target: 'Day1-许可需求', value: 1, stage: 'Day 1' },
        { source: 'CT109 HGH→BUD', target: 'Day1-许可需求', value: 1, stage: 'Day 1' },
        { source: 'CT110 HGH→HKG', target: 'Day1-许可需求', value: 1, stage: 'Day 1' },
        { source: 'CT111 HGH→FRA', target: 'Day1-许可需求', value: 1, stage: 'Day 1' },
        
        // Layer 2: Day2 批次创建
        { source: 'Day1-许可需求', target: 'Day2-BATCH001', value: 5, stage: 'Day 2' },
        
        // Layer 3: Day2 邮件发送
        { source: 'Day2-BATCH001', target: 'Day2-📧发送UAS', value: 5, stage: 'Day 2' },
        
        // Layer 4: Day5 分流处理
        { source: 'Day2-📧发送UAS', target: 'Day5-✈️变更3航班', value: 3, stage: 'Day 5' },
        { source: 'Day2-📧发送UAS', target: 'Day5-⏳等待2航班', value: 2, stage: 'Day 5' },
        
        // Layer 5: Day6 重新申请
        { source: 'Day5-✈️变更3航班', target: 'Day6-BATCH002', value: 3, stage: 'Day 6' },
        
        // Layer 6: Day6 重新发送
        { source: 'Day6-BATCH002', target: 'Day6-📧重发UAS', value: 3, stage: 'Day 6' },
        
        // Layer 7-10: 分批确认
        { source: 'Day5-⏳等待2航班', target: 'Day8-✅CT110批准', value: 1, stage: 'Day 8' },
        { source: 'Day6-📧重发UAS', target: 'Day9-✅CT107+108批准', value: 2, stage: 'Day 9' },
        { source: 'Day6-📧重发UAS', target: 'Day9-⏳CT109待处理', value: 1, stage: 'Day 9' },
        { source: 'Day5-⏳等待2航班', target: 'Day10-✅CT111批准', value: 1, stage: 'Day 10' },
        { source: 'Day9-⏳CT109待处理', target: 'Day12-✅CT109批准', value: 1, stage: 'Day 12' },
    ];

    // 纵向时间轴 - 综合事件场景数据（重新组织为纵向层次）
    const verticalData = [
        // 航班源头 → 时间段1 (08:00-09:00)
        { source: 'CT107\nHGH→NQZ', target: 'T1-09:00许可申请', value: 1, time: '09:00' },
        { source: 'CT108\nHGH→LGG', target: 'T1-09:00许可申请', value: 1, time: '09:00' },
        { source: 'CT109\nHGH→BUD', target: 'T1-08:00航班变更', value: 1, time: '08:00' },
        
        // 时间段1 → 时间段2 (09:30-10:30)
        { source: 'T1-09:00许可申请', target: 'T2-09:30BATCH001', value: 2, time: '09:30' },
        { source: 'T1-08:00航班变更', target: 'T2-08:30时刻调整', value: 1, time: '08:30' },
        { source: 'CT107\nHGH→NQZ', target: 'T2-10:00燃油申请', value: 1, time: '10:00' },
        
        // 时间段2 → 时间段3 (10:00-11:30)
        { source: 'T2-09:30BATCH001', target: 'T3-10:00📧UAS', value: 2, time: '10:00' },
        { source: 'T2-08:30时刻调整', target: 'T3-09:00通知部门', value: 1, time: '09:00' },
        { source: 'T2-10:00燃油申请', target: 'T3-10:30BATCH003', value: 1, time: '10:30' },
        { source: 'CT108\nHGH→LGG', target: 'T3-11:00配餐订单', value: 1, time: '11:00' },
        
        // 时间段3 → 时间段4 (11:00-14:30)
        { source: 'T3-10:30BATCH003', target: 'T4-11:00📧AEG', value: 1, time: '11:00' },
        { source: 'T3-11:00配餐订单', target: 'T4-11:30BATCH004', value: 1, time: '11:30' },
        { source: 'T4-11:30BATCH004', target: 'T4-12:00📧航食', value: 1, time: '12:00' },
        { source: 'CT109\nHGH→BUD', target: 'T4-14:00许可申请', value: 1, time: '14:00' },
        { source: 'T4-14:00许可申请', target: 'T4-14:30BATCH002', value: 1, time: '14:30' },
        
        // 时间段4 → 最终确认 (15:00-16:00)
        { source: 'T4-14:30BATCH002', target: 'T5-15:00📧UAS', value: 1, time: '15:00' },
        { source: 'T3-10:00📧UAS', target: 'T5-16:00✅许可批准', value: 2, time: '16:00' },
        { source: 'T5-15:00📧UAS', target: 'T5-16:00✅许可批准', value: 1, time: '16:00' },
        { source: 'T4-11:00📧AEG', target: 'T5-13:00✅燃油确认', value: 1, time: '13:00' },
        { source: 'T4-12:00📧航食', target: 'T5-14:00✅配餐确认', value: 1, time: '14:00' },
        { source: 'T3-09:00通知部门', target: 'T5-10:00✅变更生效', value: 1, time: '10:00' },
    ];

    // Alluvial Diagram数据 - 多时间点状态快照
    const alluvialData = {
        nodes: [
            // 时间点1: 航班初始状态
            { name: 'CT107', category: 'flight', timeStep: 'T1-初始', x: 0 },
            { name: 'CT108', category: 'flight', timeStep: 'T1-初始', x: 0 },
            { name: 'CT109', category: 'flight', timeStep: 'T1-初始', x: 0 },

            // 时间点2: 事务创建
            { name: '许可申请', category: 'transaction', timeStep: 'T2-事务创建', x: 1 },
            { name: '燃油申请', category: 'transaction', timeStep: 'T2-事务创建', x: 1 },
            { name: '配餐订单', category: 'transaction', timeStep: 'T2-事务创建', x: 1 },
            { name: '航班变更', category: 'transaction', timeStep: 'T2-事务创建', x: 1 },

            // 时间点3: 批次汇聚
            { name: 'BATCH-001', category: 'batch', timeStep: 'T3-批次汇聚', x: 2 },
            { name: 'BATCH-002', category: 'batch', timeStep: 'T3-批次汇聚', x: 2 },
            { name: 'BATCH-003', category: 'batch', timeStep: 'T3-批次汇聚', x: 2 },
            { name: 'BATCH-004', category: 'batch', timeStep: 'T3-批次汇聚', x: 2 },

            // 时间点4: 供应商处理
            { name: 'UAS处理', category: 'supplier', timeStep: 'T4-供应商处理', x: 3 },
            { name: 'AEG处理', category: 'supplier', timeStep: 'T4-供应商处理', x: 3 },
            { name: '航食处理', category: 'supplier', timeStep: 'T4-供应商处理', x: 3 },
            { name: '机场处理', category: 'supplier', timeStep: 'T4-供应商处理', x: 3 },

            // 时间点5: 最终状态
            { name: '许可已批准', category: 'result', timeStep: 'T5-最终状态', x: 4 },
            { name: '燃油已确认', category: 'result', timeStep: 'T5-最终状态', x: 4 },
            { name: '配餐已确认', category: 'result', timeStep: 'T5-最终状态', x: 4 },
            { name: '变更已生效', category: 'result', timeStep: 'T5-最终状态', x: 4 },
        ],
        links: [
            // T1 → T2: 航班到事务
            { source: 0, target: 3, value: 1, time: '09:00', batch: 'BATCH-001' }, // CT107 → 许可申请
            { source: 1, target: 3, value: 1, time: '09:00', batch: 'BATCH-001' }, // CT108 → 许可申请
            { source: 0, target: 4, value: 1, time: '10:00', batch: 'BATCH-002' }, // CT107 → 燃油申请
            { source: 1, target: 5, value: 1, time: '11:00', batch: 'BATCH-003' }, // CT108 → 配餐订单
            { source: 2, target: 6, value: 1, time: '08:00', batch: 'BATCH-004' }, // CT109 → 航班变更
            { source: 2, target: 3, value: 1, time: '14:00', batch: 'BATCH-001' }, // CT109 → 许可申请

            // T2 → T3: 事务到批次
            { source: 3, target: 7, value: 3, time: '09:30' },  // 许可申请 → BATCH-001
            { source: 4, target: 8, value: 1, time: '10:30' },  // 燃油申请 → BATCH-002
            { source: 5, target: 9, value: 1, time: '11:30' },  // 配餐订单 → BATCH-003
            { source: 6, target: 10, value: 1, time: '08:30' }, // 航班变更 → BATCH-004

            // T3 → T4: 批次到供应商
            { source: 7, target: 11, value: 3, time: '10:00' }, // BATCH-001 → UAS处理
            { source: 8, target: 12, value: 1, time: '11:00' }, // BATCH-002 → AEG处理
            { source: 9, target: 13, value: 1, time: '12:00' }, // BATCH-003 → 航食处理
            { source: 10, target: 14, value: 1, time: '09:00' }, // BATCH-004 → 机场处理

            // T4 → T5: 供应商到最终状态
            { source: 11, target: 15, value: 3, time: '16:00' }, // UAS处理 → 许可已批准
            { source: 12, target: 16, value: 1, time: '13:00' }, // AEG处理 → 燃油已确认
            { source: 13, target: 17, value: 1, time: '14:00' }, // 航食处理 → 配餐已确认
            { source: 14, target: 18, value: 1, time: '10:00' }, // 机场处理 → 变更已生效
        ]
    };

    // 初始化横向图表
    useEffect(() => {
        if (activeTab === 'horizontal' && horizontalContainerRef.current && !horizontalChartRef.current) {
            const sankey = new Sankey(horizontalContainerRef.current, {
                data: horizontalData,
                sourceField: 'source',
                targetField: 'target',
                weightField: 'value',
                width: 1000,
                height: 600,
                nodeWidthRatio: 0.03,
                nodePaddingRatio: 0.08,
                color: [
                    '#1890FF', '#52C41A', '#FAAD14', '#F5222D', '#722ED1', 
                    '#13C2C2', '#FA8C16', '#EB2F96'
                ],
                label: {
                    fields: ['name'],
                    callback: (name) => {
                        if (name.includes('-')) {
                            const parts = name.split('-');
                            return parts[1] || parts[0];
                        }
                        return name.length > 12 ? name.substring(0, 10) + '...' : name;
                    },
                    style: {
                        fontSize: 10,
                        fill: '#333333',
                        fontWeight: 'bold',
                    },
                },
                tooltip: {
                    fields: ['source', 'target', 'value', 'stage'],
                    formatter: (datum) => ({
                        name: `${datum.source} → ${datum.target}`,
                        value: `航班数: ${datum.value}${datum.stage ? ` | 阶段: ${datum.stage}` : ''}`,
                    }),
                },
                nodeStyle: {
                    fillOpacity: 0.9,
                    lineWidth: 2,
                    stroke: '#d9d9d9',
                    cursor: 'pointer',
                },
                edgeStyle: {
                    fillOpacity: 0.7,
                    lineWidth: 1,
                    stroke: '#f0f0f0',
                    cursor: 'pointer',
                },
            });

            sankey.render();
            horizontalChartRef.current = sankey;
        }
    }, [activeTab, horizontalData]);

    // 初始化纵向图表
    useEffect(() => {
        if (activeTab === 'vertical' && verticalContainerRef.current && !verticalChartRef.current) {
            const sankey = new Sankey(verticalContainerRef.current, {
                data: verticalData,
                sourceField: 'source',
                targetField: 'target',
                weightField: 'value',
                width: 600,
                height: 800,
                nodeWidthRatio: 0.03,
                nodePaddingRatio: 0.05,
                color: [
                    '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', 
                    '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9'
                ],
                label: {
                    fields: ['name'],
                    callback: (name) => {
                        if (name.includes('\n')) {
                            return name.replace('\n', ' ');
                        }
                        if (name.includes('-')) {
                            const parts = name.split('-');
                            return parts[1] || parts[0];
                        }
                        return name.length > 8 ? name.substring(0, 6) + '...' : name;
                    },
                    style: {
                        fontSize: 9,
                        fill: '#333333',
                        fontWeight: 'bold',
                    },
                },
                tooltip: {
                    fields: ['source', 'target', 'value', 'time'],
                    formatter: (datum) => ({
                        name: `${datum.source} → ${datum.target}`,
                        value: `数量: ${datum.value}${datum.time ? ` | 时间: ${datum.time}` : ''}`,
                    }),
                },
                nodeStyle: {
                    fillOpacity: 0.9,
                    lineWidth: 2,
                    stroke: '#d9d9d9',
                    cursor: 'pointer',
                },
                edgeStyle: {
                    fillOpacity: 0.8,
                    lineWidth: 1,
                    stroke: '#f0f0f0',
                    cursor: 'pointer',
                },
            });

            sankey.render();
            verticalChartRef.current = sankey;
        }
    }, [activeTab, verticalData]);

    // 刷新图表
    const refreshChart = () => {
        if (activeTab === 'horizontal' && horizontalChartRef.current) {
            horizontalChartRef.current.destroy();
            horizontalChartRef.current = null;
        } else if (activeTab === 'vertical' && verticalChartRef.current) {
            verticalChartRef.current.destroy();
            verticalChartRef.current = null;
        }
        message.success('图表已刷新');
    };

    // 全屏显示
    const toggleFullscreen = () => {
        const container = activeTab === 'horizontal' ? horizontalContainerRef.current : verticalContainerRef.current;
        if (container) {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
                container.requestFullscreen();
            }
        }
    };

    const tabItems = [
        {
            key: 'horizontal',
            label: '横向时间轴 - 许可申请场景',
            children: (
                <div>
                    <div style={{ marginBottom: "16px" }}>
                        <Space wrap>
                            <Tag color="blue">5个航班</Tag>
                            <Tag color="green">许可申请事务</Tag>
                            <Tag color="orange">航班变更场景</Tag>
                            <Tag color="purple">分批回复</Tag>
                        </Space>
                        <Divider />
                        <Text>
                            <strong>场景描述：</strong>
                            5个航班(CT107-CT111)一起申请许可，第5天时其中3个航班因航班变更需要重新申请，
                            最终在不同时间点分批获得批准。横轴表示时间进展，不同时间的节点按层次分布。
                        </Text>
                    </div>
                    <div
                        ref={horizontalContainerRef}
                        style={{
                            width: "100%",
                            height: "600px",
                            border: "1px solid #f0f0f0",
                            borderRadius: "6px",
                            backgroundColor: "#fafafa",
                        }}
                    />
                </div>
            )
        },
        {
            key: 'vertical',
            label: '纵向时间轴 - 综合事件场景',
            children: (
                <div>
                    <div style={{ marginBottom: "16px" }}>
                        <Space wrap>
                            <Tag color="red">3个航班</Tag>
                            <Tag color="cyan">多种事务类型</Tag>
                            <Tag color="gold">时间维度</Tag>
                            <Tag color="purple">综合场景</Tag>
                        </Space>
                        <Divider />
                        <Text>
                            <strong>场景描述：</strong>
                            3个航班在同一天内发生多种事务：许可申请、燃油申请、配餐订单、航班变更等，
                            展示了一个完整工作日内各种事务的并行处理过程。图表已旋转90度，纵向展示时间推进。
                        </Text>
                    </div>
                    <div style={{ 
                        width: '100%', 
                        height: '800px', 
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid #f0f0f0',
                        borderRadius: '6px',
                        backgroundColor: '#fafafa',
                        overflow: 'hidden'
                    }}>
                        <div 
                            ref={verticalContainerRef}
                            style={{ 
                                width: '600px', 
                                height: '800px',
                                transform: 'rotate(90deg) scale(0.8)',
                                transformOrigin: 'center center'
                            }}
                        />
                    </div>
                </div>
            )
        },
        {
            key: 'alluvial',
            label: 'Alluvial图 - 多时间点状态流',
            children: (
                <div>
                    <div style={{ marginBottom: "16px" }}>
                        <Space wrap>
                            <Tag color="blue">3个航班</Tag>
                            <Tag color="green">5个时间点</Tag>
                            <Tag color="orange">状态快照</Tag>
                            <Tag color="purple">流向分析</Tag>
                        </Space>
                        <Divider />
                        <Text>
                            <strong>场景描述：</strong>
                            使用Alluvial图展示航班事务在多个时间点的状态变化，从初始状态到事务创建、批次汇聚、
                            供应商处理，最终到完成状态。每个时间点显示所有实体的状态快照，连线显示状态间的流向。
                        </Text>
                    </div>
                    <div style={{
                        width: '100%',
                        minHeight: '700px',
                        border: '1px solid #f0f0f0',
                        borderRadius: '6px',
                        backgroundColor: '#fafafa'
                    }}>
                        <SimpleAlluvialDemo />
                    </div>
                </div>
            )
        }
    ];

    return (
        <div style={{ padding: '24px' }}>
            <Card>
                <div style={{ marginBottom: '24px' }}>
                    <Title level={2}>航班事务流向图演示</Title>
                    <Text type="secondary">
                        使用桑基图可视化航班事务的分流汇聚过程，展示多航班、多批次、时间维度的复杂关系
                    </Text>
                </div>

                <Tabs 
                    activeKey={activeTab} 
                    onChange={setActiveTab}
                    items={tabItems}
                    tabBarExtraContent={
                        <Space>
                            <Button icon={<ReloadOutlined />} onClick={refreshChart}>
                                刷新
                            </Button>
                            <Button icon={<FullscreenOutlined />} onClick={toggleFullscreen}>
                                全屏
                            </Button>
                        </Space>
                    }
                />
            </Card>
        </div>
    );
};

export default SankeyFlowDemo;
